import localStorage from '@/plugins/localStorage';

export default {
  setProp(state, obj) {
    state[obj.key] = obj.value;
  },
  init(state) {
    state.init = true;

    const accountString = localStorage.getItem('accountObj');
    const tokenExpires = localStorage.getItem('tokenExpires');

    if (!accountString || !tokenExpires) return false;
    if (state.needCheckExparation && parseFloat(Date.now()) > parseFloat(tokenExpires)) {
      localStorage.removeItem('accountObj');
      localStorage.removeItem('tokenExpires');
    } else {
      state.account.token = accountString;
      state.account.exparation = parseFloat(tokenExpires);
    }

    return true;
  },
  setToken(state, data) {
    localStorage.setItem('accountObj', data.token);
    localStorage.setItem('tokenExpires', 0);
    state.account.token = data.token;
    state.account.exparation = 0;
  },
  setUser(state, user) {
    state.user.data = user;
  },
  removeToken(state) {
    localStorage.removeItem('accountObj');
    localStorage.removeItem('tokenExpires');
    state.account.token = '';
    state.account.exparation = 0;
  },
};
